export const manifest = {
  screens: {
    scr_4qmz24: { name: "Home", route: "/" },
  },
}
